export const nzIndustryOptions = [
  { label: "Advertising", value: "ADVERTISING" },
  { label: "Agri/Forestry", value: "AGRI" },
  { label: "Armed Force", value: "ARMED_FORCE" },
  { label: "Banking/Finance", value: "BANKING" },
  { label: "Civil Services", value: "CIVIL_SERVICES" },
  { label: "Cleaning/Laundry", value: "CLEANING" },
  { label: "Computer Staff", value: "COMPUTER_STAFF" },
  { label: "Construction", value: "CONSTRUCTION" },
  { label: "Education", value: "EDUCATION" },
  { label: "Emergency Service", value: "EMERGENCY_SERVICE" },
  { label: "Home Duties", value: "HOME_DUTIES" },
  { label: "Hospital", value: "HOSPITAL" },
  { label: "Hotel", value: "HOTEL" },
  { label: "Industrial Services", value: "INDUSTRY_SERVICES" },
  { label: "Insurance", value: "INSURANCE" },
  { label: "Manufacturing", value: "MANUFACTURING" },
  { label: "Media", value: "MEDIA" },
  { label: "Mining", value: "MINING" },
  { label: "Other", value: "OTHER" },
  { label: "Pensioner", value: "PENSIONER" },
  { label: "Leisure/Entertainment", value: "LEISURE" },
  { label: "Property/Business", value: "PROPERTY" },
  { label: "Restaurant", value: "RESTAURANT" },
  { label: "Retail/Wholesale", value: "RETAIL" },
  { label: "Retired", value: "RETIRED" },
  { label: "Sciences", value: "SCIENCES" },
  { label: "Student", value: "STUDENT" },
  { label: "Transport", value: "TRANSPORT" },
  { label: "Unemployed", value: "UNEMPLOYED" },
  { label: "Seasonal", value: "SEASONAL" },
] as const;
